import request from '@utils/request';
import url from '@utils/url';

const { HOST } = url;

export async function search(data) {
    const url = `${HOST}/cps-gateway/api/v1/bill/game`;

    return request({ method: 'post', url: url }, data);
}

export async function download(data, downloadType) {
    let url = `${HOST}/cps-gateway/api/v1/bill/game`;
    url += downloadType ? '/detail/download' : '/download';
    
    return request({ method: 'post', url: url, responseType: 'blob' }, data);
}
 
export async function billDetails(data) {
    const url = `${HOST}/cps-gateway/api/v1/bill/game/detail`;

    return request({ method: 'post', url: url }, data);
}